import React from 'react';
import { cn } from './_cn';

const variants = {
  card: 'rounded-md border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800',
  dashed:
    'rounded-md border border-dashed border-slate-200 bg-slate-50/50 dark:border-slate-700 dark:bg-slate-800/30',
  plain: '',
};

const EmptyState = ({
  icon: Icon,
  image,
  title = 'No data',
  description,
  action,
  variant = 'card',
  className = '',
}) => (
  <div
    className={cn(
      'flex min-h-[180px] flex-col items-center justify-center gap-3 px-6 py-10 text-center',
      variant in variants ? variants[variant] : variants.card,
      className,
    )}
  >
    {image ? (
      <img src={image} alt="" className="h-20 w-20 opacity-80" />
    ) : Icon ? (
      <span className="flex h-12 w-12 items-center justify-center rounded-md bg-slate-100 text-slate-400 dark:bg-slate-700 dark:text-slate-300">
        <Icon className="h-6 w-6" aria-hidden />
      </span>
    ) : null}
    {title ? (
      <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
        {title}
      </p>
    ) : null}
    {description ? (
      <p className="max-w-xs text-xs text-slate-500 dark:text-slate-400">
        {description}
      </p>
    ) : null}
    {action ? <div className="pt-1">{action}</div> : null}
  </div>
);

export default EmptyState;
